/**
 * Bind edit link: prevent default, close dropdown, switch to edit mode, init listing autocomplete.
 * callbacks: { toggleTopMode(popup, mode), initInlineEditListingAutocomplete(popup) }
 */
export function initEditLink(editLink, callbacks = {}) {
  if (editLink.dataset.bound === 'true') {
    return;
  }

  editLink.dataset.bound = 'true';
  editLink.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const popup = editLink.closest('.js-showing-view-popup') || document.querySelector('.js-sm-modal .js-showing-view-popup');
    if (typeof SMDropdown !== 'undefined') {
      SMDropdown.closeAll();
    }
    callbacks.toggleTopMode?.(popup, 'edit');
    callbacks.initInlineEditListingAutocomplete?.(popup);
  });
}
